import styles from '@components/components/ProductComponentsLegacy/ProductCardEyecatcher/ProductCardEyecatcher.module.scss';
import React from 'react';
import classNames from 'classnames';
import { DialogDisclosure } from '@ariakit/react';
import { Content, FontAwesomeProIcon, Modal } from '@wienenergiegithub/ui-next';

const ProductCardEyecatcherLegacy = ({
  eyecatcher,
  promoDialog,
  recommendedProduct,
}) => (
  <Content className={styles.container} size="md">
    {!!recommendedProduct && (
      <span className={styles.recommended}>Empfohlener Tarif</span>
    )}
    <div className={styles.eyeCatcherContainer}>
      <span className={styles.text}>{eyecatcher?.text}</span>
      {eyecatcher?.legalText && (
        <>
          <DialogDisclosure
            aria-label="Mehr Informationen über die Aktion"
            className={classNames(
              styles.informationButton,
              styles.promoDialogButton,
            )}
            store={promoDialog}
          >
            <FontAwesomeProIcon
              className={styles.promoDialogIcon}
              fixedWidth
              icon="info-circle"
              role="presentation"
              type="regular"
            />
          </DialogDisclosure>
          <Modal header={eyecatcher.text} store={promoDialog} theme="default">
            <Content noSpacing withParser>
              {eyecatcher.legalText}
            </Content>
          </Modal>
        </>
      )}
    </div>
  </Content>
);

export default ProductCardEyecatcherLegacy;
